import * as CubeTree from '../../cubeTree/index';
import { StageEvent } from '../../message/index';
import Config from '../../config';
import Utils from '../../utils/util';
import Update from '../../update';
import CabinetTransfer from '../../interaction/cabinetTransfer';

function init(): void {
    StageEvent.on('cabinetSkuColLayout', (params: FreeObjMap): void => {
        if (params.eventFrom === 'stage') {
            return;
        }

        let isTrans: boolean = Config.get({
            moduleName: 'freezer',
            key: 'cabinetTransLayout'
        });
        let stage: CubeId = CubeTree.findSketchpad();

        if (isTrans) {
            Update.forceCubeModify(stage, 'cubeData.crossShelf', 1);
        }
        else {
            Update.forceCubeModify(stage, 'cubeData.crossShelf', 0);
        }

        isTrans ? CabinetTransfer.open() : CabinetTransfer.close();
    });
}

export default {
    init
};
